import useSWR from "swr";

import { GetVersion } from "api";

export const useVersion = () => {
  return useSWR<GetVersion>("/api/actuator/info", {
    refreshInterval: +process.env.REFRESH_INTERVAL_MS,
  });
};
